import type { ResourceKey } from 'i18next'
import enShared from './web-shared-en.json'
import beShared from './web-shared-be.json'
import ruShared from './web-shared-ru.json'
import beManager from './web-manager-be.json'
import ruManager from './web-manager-ru.json'
import enManager from './web-manager-en.json'

export const englishSharedTranslation = enShared as ResourceKey
export const englishManagerTranslation = enManager as ResourceKey
export const russianSharedTranslation = ruShared as ResourceKey
export const russianManagerTranslation = ruManager as ResourceKey
export const belarusSharedTranslation = beShared as ResourceKey
export const belarusManagerTranslation = beManager as ResourceKey
